__webpack_require__.p = "https://www.logo-editor.com/";